import { render, staticRenderFns } from "./AdGroupKeyword.vue?vue&type=template&id=48f016ac&scoped=true&lang=pug&"
import script from "./AdGroupKeyword.vue?vue&type=script&lang=js&"
export * from "./AdGroupKeyword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f016ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/zx/@sdc/toolkit/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VContainer,VDataTable,VFlex,VIcon,VLayout})
